const API_ROOT = process.env.REACT_APP_RootURI + "/api/";

export const fetchService = (endpoint, options) =>
    fetch(API_ROOT + endpoint, {
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        }, ...options
    })
        .then(response => response.json()).then(response => {
            if (response.status === 500) Promise.reject(response);
            return Promise.resolve(response);
        });